export const FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10MiB
export const FILE_SIZE_BYTES_FOR_GOOGLE = 5 * 1024 * 1024; // 5MiB
